// Peticiones HTTP hacia el backend .NET
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class WalletService {
  private API_URL = environment.URL_API_MAGNO;
  constructor(private http: HttpClient) { }
  checkEmail(email: string) { return this.http.post(`${this.API_URL}/api/Wallet/CheckEmail`, { Email: email }); }
  verifyPassword(email: string, pass: string) { return this.http.post(`${this.API_URL}/api/Wallet/VerifyPassword`, { Email: email, Password: pass }); }
  createPassword(email: string, pass: string) { return this.http.post(`${this.API_URL}/api/Wallet/CreatePassword`, { Email: email, Password: pass }); }
  verifyCode(email: string, code: string) { return this.http.post(`${this.API_URL}/api/Wallet/VerifyCode`, { Email: email, Code: code }); }

  getBoletos() {
    return this.http.get(`${this.API_URL}/api/Wallet/MisBoletos`);
  }
}